import { memo } from 'react';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';

const NoData = styled.div`
  padding: 8px 16px;
  background: var(--fett-bg-subtle);
  color: var(--fett-text-tertiary);
  font-size: 14px;
`;

function TradeDetailNoData() {
  const { t } = useTranslate();

  return <NoData>{t('scene.chatWorkspace.orderTab.empty.noData')}</NoData>;
}

export default memo(TradeDetailNoData);
